import Gravity from 'gravityglobal-parent/assets/js/global-functions';

const initHeader = () => {
    const header = document.querySelector('.gg-navigation');

    if (!header) {
        return;
    }

    const DOMReplacementElement = header.parentElement.querySelector('.gg-navigation__dom-replacement');
    const menu = header.querySelector('.gg-navigation__main-menu');
    const search = header.querySelector('.gravity-block-search');
    const primaryButton = header.querySelector('.gg-navigation__primary-button');
    const secondaryButton = header.querySelector('.gg-navigation__secondary-button');
    const drawerLogo = header.querySelector('.gg-navigation__drawer-logo');
    const announcement = header.querySelector('.announcement');
    const megaMenus = header.querySelectorAll('.gravity-block-navigation__mega-menu');
    const btnCloseAnnouncement = announcement ? announcement.querySelector('.gg-button-announce a') : null;
    const wrapperNavMobile = header.querySelector('.gravity-block-navigation__wrapper');
    const lis = wrapperNavMobile.querySelectorAll('li');
    const buttons = wrapperNavMobile.querySelectorAll('button');
    const flyoutBack = header.querySelectorAll('.gg-flyout__flyout-back')
    const btnClickMega = header.querySelectorAll('.gravity-block-navigation__item--mega-menu button')
    const itemMegaMenus = header.querySelectorAll('.gravity-block-navigation__item--mega-menu')
    const buttonContactMobile = header.querySelector('.gravity-block-navigation__after-wrapper')
    const projectHasStickySubNav = false;
    let lastScrollTop = 0;
    let headerScrollTimeout = null;
    let headerHeight = header.offsetHeight;
    const announcementModal = 'announcementShown';
    const days = 365;



    const moveItemsToDrawer = (itemsBefore, itemsAfter) => {
        // itemsBefore?.forEach((item) => {
        //     menu?.gravity?.registerBeforeWrapper(item);
        // });

        itemsAfter?.forEach((item) => {
            menu?.gravity?.registerAfterWrapper(item);
        });

        menu?.gravity?.moveExternalElements();

        document.body.classList.add('gg-navigation--initialized');
    };

    btnClickMega.forEach((button) => {
        button.addEventListener('click', () => {
            if (!menu.classList.contains('open-mega')) {
                menu.classList.add('open-mega');
            }
        });
    });

    flyoutBack.forEach((backButton) => {
        backButton.addEventListener('click', () => {
            const subMenus = header.querySelectorAll('.gravity-block-navigation__item--mega-menu');
            menu.classList.remove('open-mega');
            subMenus.forEach((subMenu) => {
                if (subMenu.classList.contains('gravity-block-navigation__sub-menu--open')) {
                    subMenu.classList.remove('gravity-block-navigation__sub-menu--open');
                }
            });
        });
    });

    function addHoveringClass() {
        header.classList.add('hovering-submenu');
    }
    
    function removeHoveringClass() {
        header.classList.remove('hovering-submenu');
    }

    const handleResize = () => {
        if (window.innerWidth < 1025) {
            headerHeight = header.offsetHeight;
            wrapperNavMobile.style.marginTop = `${headerHeight + 30}px`;
            megaMenus.forEach((menu) => {
                menu.style.top = '';
            });
        } else {
            wrapperNavMobile.style.marginTop = '';
            megaMenus.forEach((menu, index) => {
                if (index === megaMenus.length - 1) {
                    menu.style.top = `${header.offsetHeight + 6}px`;
                } else {
                    menu.style.top = `${header.offsetHeight}px`;
                }
            });
        }
    };

    const setPaddingTopFirstSection = () => {
        const firstSection = document.querySelector('.gg-main section:first-child .padding-header');
        if (firstSection) {
            const headerHeight = header.offsetHeight;
            const heightDevice = window.innerWidth < 1025 ? 30 : 40;
            firstSection.style.paddingTop = `${headerHeight + heightDevice}px`;
        }
    }

    window.addEventListener('load', () => {
        setPaddingTopFirstSection();
        handleResize();
        addActiveMenu();
    });

    window.addEventListener('resize', () => {
        setPaddingTopFirstSection();
        handleResize();
    });

    if (window.innerWidth < 768) {
      moveItemsToDrawer([drawerLogo], [primaryButton, secondaryButton]);
    }

    const navObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            megaMenus.forEach(menu => {
                menu.addEventListener('mouseover', addHoveringClass);
                menu.addEventListener('mouseout', removeHoveringClass);
            });
            header.classList.toggle('at-the-top', entry.isIntersecting);
            header.classList.toggle('scroll', !entry.isIntersecting);
        });
    });

    const searchObserver = new MutationObserver((mutations) => {
        mutations.forEach(({target, attributeName}) => {
            if (attributeName === 'class') {
                header.classList.toggle('active-search', target.classList.contains('gravity-block-search--show'));
            }
        });
    });

    const setCookie = (cname, cvalue, exdays) => {
        const d = new Date();
        const expiresEq = 'expires=';
        const eq = '=';
        const comma = ';';
        const path = ';path=/';
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = `${expiresEq + d.toUTCString()}`;
        document.cookie = `${cname + eq + cvalue + comma + expires + path}`;
    };

    if (!projectHasStickySubNav) {
        let lastScrollTop = window.scrollY || document.documentElement.scrollTop;
        let isScrolling = false;
    
        const hideShowHeader = () => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const modules = document.querySelectorAll('.gg-animated-enterprise-accounting__content');

            if(modules.length > 0) {
                modules.forEach(module => {
                    const stickyPosition = module.getBoundingClientRect().top;
                    if (stickyPosition >= -module.offsetHeight && stickyPosition <= 0) {
                        header.classList.add('hidden');
                        header.classList.remove('hovering');
                    } else if (scrollTop <= lastScrollTop && stickyPosition < -module.offsetHeight || scrollTop <= lastScrollTop && stickyPosition > 0) {
                        header.classList.remove('hidden');
                    } else {
                        header.classList.add('hidden');
                        header.classList.remove('hovering');
                    }
                });
            } else {
                if (scrollTop > lastScrollTop) {
                    header.classList.add('hidden');
                    header.classList.remove('hovering');
                } else if (scrollTop <= lastScrollTop) {
                    header.classList.remove('hidden');
                }
            }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
            isScrolling = false;
        };
    
        const onScroll = () => {
            if (!isScrolling) {
                window.requestAnimationFrame(hideShowHeader);
                isScrolling = true;
            }
        };
    
        window.addEventListener('scroll', onScroll);
    }    
    
    if (search) {
        searchObserver.observe(search, {attributes: true});
    }

    if (navObserver) {
        navObserver.observe(DOMReplacementElement);
    }

    const getCookie = (name) => {
        const namePattern = name + "=";

        const decodedCookie = decodeURIComponent(document.cookie);
        const cookiesArray = decodedCookie.split(';');

        for (let i = 0; i < cookiesArray.length; i++) {
            let cookie = cookiesArray[i].trim();

            if (cookie.indexOf(namePattern) === 0) {
                return cookie.substring(namePattern.length, cookie.length);
            }
        }

        return null;
    }

    if (btnCloseAnnouncement && announcement) {
        btnCloseAnnouncement.addEventListener('click', () => {
            announcement.style.display = 'none'
            const cookieName = `${announcementModal}`;
            setCookie(cookieName, 2, days);
            setPaddingTopFirstSection()
            handleResize()
        });
    }

    if (announcement) {
        const cookieName = `${announcementModal}`;
        if (getCookie(cookieName) == null) {
            setCookie(cookieName, 1, days);
            announcement.style.display = 'flex';
        }
        else if (getCookie(cookieName) == 1) {
            setCookie(cookieName, 1, days);
            announcement.style.display = 'flex';
        } else {
            setCookie(cookieName, 2, days);
            announcement.style.display = 'none';
        }
    } else {
        const cookieName = `${announcementModal}`;
        if (getCookie(cookieName) == null) {
            setCookie(cookieName, 2, days);
        }
    }
    itemMegaMenus.forEach((item) => {
        item.addEventListener('mouseenter', () => {
            header.classList.add('hovering');
            addHoveringClass();
        });
        item.addEventListener('mouseleave', () => {
            header.classList.remove('hovering');
            removeHoveringClass();
        });
        if (window.innerWidth < 1024) {
            const linkElement = item.querySelector('a.gravity-block-navigation__item-content ');
            linkElement.addEventListener('click', (e) => {
                const buttonElement = item.querySelector('button');
                if (buttonElement) {
                    buttonElement.click();
                }
            });
        }
    });

    setPaddingTopFirstSection();
    handleResize();
    addActiveMenu();

    function addActiveMenu() {
        const currentUrl = window.location.href;
        const linksMenu = document.querySelectorAll('.gravity-block-navigation__item > a');
        const linksMegaMenu = document.querySelectorAll('.gravity-block-navigation__mega-menu a');
        const bodyClassList = document.body.classList;
        const isSingle = bodyClassList.contains('single');
        
        linksMenu.forEach(link => {

            if (link.href === currentUrl) {
                link.parentElement.classList.add('active');
            }
        });
    
        linksMegaMenu.forEach(link => {
            const linkNew = link.href.includes('/solutions/products/') ? link.href.replace('/products', '') : null;
            if (link.href === currentUrl || linkNew === currentUrl) {
                const parentLink = link.parentElement;
                const grandParentLink = parentLink.parentElement;
                
                grandParentLink.classList.add('active-sub');
    
                if (grandParentLink.classList.contains('gravity-block-dynamic-boxes--grid-view')) {
                    const heading = link.querySelector('span');
                    if (heading) {
                        heading.classList.add('wp-block-heading');
                    }
                }
    
                linksMenu.forEach(menuLink => {
                    if (link.closest('.gravity-block-navigation__item') === menuLink.parentElement) {
                        menuLink.parentElement.classList.add('active');
                    }
                });
            }
    
            if (isSingle) {
                const urlParts = currentUrl.split('/');
                if (urlParts.length > 3) {
                    let formattedText = urlParts[3].replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
    
                    if (formattedText === 'On Demand Webinars') {
                        formattedText = formattedText.replace('On Demand ', '');
                    } else if (formattedText === 'White Papers') {
                        formattedText = formattedText.replace('White Papers', 'Whitepapers');
                    }
    
                    const container = link.closest('.gg-container-1180');
                    if (container) {
                        container.querySelectorAll('.wp-block-group').forEach(item => {
                            if (item.textContent.trim() === formattedText && !item.classList.contains('active-sub')) {
                                item.classList.add('active-sub');
                                item.closest('.gravity-block-navigation__item--mega-menu').classList.add('active');
                            }
                        });
                    }
                }
            }
        });
    }
    

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        if(index === (buttons.length - 1)) {
          buttonContactMobile.style.translate = '0';
        }
        else {
          buttonContactMobile.style.removeProperty('translate');
        }
      });
    });
};
export default initHeader;
